import React, { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';

import './index.scss';

export const AdminPanel = () => {
    const { role } = useAppSelector((state) => state.profileReducer);
    const navigate = useNavigate();

    useEffect(() => {
        if (!role) return;
        if (role !== 'super_admin' && role !== 'onboarding_representative') {
            navigate('/page-not-found');
        }
    }, [role]);

    return (
        <div className="admin-panel">
            <div className="admin-panel__nav nav">
                <div className="nav__title">Admin panel</div>

                {role === 'super_admin' && (
                    <>
                        <NavLink to="users">Users</NavLink>
                        <NavLink to="organisations">Organisations</NavLink>
                        <NavLink to="suppliers">Suppliers</NavLink>
                        <NavLink to="expense_areas">Expense Areas</NavLink>
                    </>
                )}
                {role !== 'super_admin' && <NavLink to="suppliers">Suppliers</NavLink>}
            </div>

            <div className="admin-panel__content">
                <Outlet />
            </div>
        </div>
    );
};
